import { Component, Vue } from "vue-property-decorator";
import { FormRow } from "../models/Form";
@Component
export default class FormsGlobal extends Vue {
  static getComponent(type: string, isParent: boolean) {
    if (isParent) {
      return 'FieldsetWrap';
    }

    const componentMapping: { [key: string]: string } = {
      '000000': 'DescriptionField',
      '000001': 'CheckField',
      '000002': 'TextField',
      '000003': 'IntegerField',
      '000004': 'DecimalField',
      '000006': 'ComboField',
      '000007': 'DateAndTimeField',
      '000008': 'SQLInputField',
      '000010': 'TextAreaField',
      'FILE': 'FileField'
    };

    return componentMapping[type] || 'DescriptionField';
  }

  static sortedRows(rows: { [key: string]: FormRow }) {
    return Object.values(rows).sort((a, b) => a.order - b.order);
  }

  static filteredSortedRows(rows: { [key: string]: FormRow }, processedRows: Set<string>) {
    return this.sortedRows(rows).filter(row => {
        return !processedRows.has(row.rowCode) && (!row.parentId || row.isParent);
    });
}

}
